import styled from 'astroturf/react'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
import { IconUser } from '@calendly/ui/components/glyphs/IconUser'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import PropTypes from 'prop-types'
import { DetailsItem } from '@calendly/booking-kit'
import _IconWrapper from "publisher-IconWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/components/publisher.js?styleId=IconWrapper";
import _PublisherName from "publisher-PublisherName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/components/publisher.js?styleId=PublisherName";


const IconWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
})

const PublisherName = /*#__PURE__*/styled('span', null, {
  displayName: "PublisherName",
  styles: _PublisherName
})

export const Publisher = ({ name, bookingAppRedesign = false }) => {
  const isPhone = useDeviceType('isPhone')
  return (
    <DetailsItem>
      {isPhone && (
      <IconWrapper>
        <UiIcon icon={IconUser} size={bookingAppRedesign ? 'small' : 'medium'} spacingRight="8" data-id="duration-item-icon" />
      </IconWrapper>
      )}
      {isPhone ? name : <PublisherName>{name}</PublisherName>}
    </DetailsItem>
  )
}

Publisher.propTypes = {
  name: PropTypes.string.isRequired,
  bookingAppRedesign: PropTypes.bool
}
